import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { AuthService } from "@auth0/auth0-angular";
import { environment } from "@environments/environment";
import { catchError, from, Observable, of, switchMap, tap } from "rxjs";

@Injectable()
export class ApiHttpInterceptor implements HttpInterceptor {

  private auth = inject(AuthService);

  private readonly backendUrl = environment.api.backendUrl;

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const isRelative = !/^https?:\/\//i.test(req.url);
    const fullUrl = isRelative ? `${this.backendUrl}${req.url}` : req.url;

    const reqWithDomain = isRelative ? req.clone({ url: fullUrl }) : req;
    console.log('Http request');
    // Attach token for private routes
    return from(this.auth.getAccessTokenSilently()).pipe(
      catchError(() => of(null)), // Handle failure by returning null
      switchMap(token => {
        if (!token) {
          return next.handle(reqWithDomain); // Proceed without authentication
        }

        const reqWithAuth = reqWithDomain.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`
          }
        });
    
        return next.handle(reqWithAuth);
      })
    );
  }
}
